module.exports = "/assets/data/59b813d40f87be9a9919df9169770825-CH8.data.json";